import React, { useEffect, useMemo } from "react";
import { Maximize2 } from "react-feather";

// Shows an already-fetched file inline (2026-09-30: "the attachment should be visible by
// default, without clicking the view button"). Images render as a picture, PDFs as an
// embedded first-page view; anything else falls back to the file name. A transparent
// layer on top catches the click (an iframe swallows clicks) and opens the full preview.
const InlineFilePreview = ({ blob, fileName, onOpen, width = 220, height = 280, loading }) => {
  const url = useMemo(() => (blob ? URL.createObjectURL(blob) : null), [blob]);
  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);

  const type = String(blob?.type || "").toLowerCase();
  const ext = String(fileName || "").split(".").pop().toLowerCase();
  const isPdf = type.includes("pdf") || ext === "pdf";
  const isImage = type.startsWith("image/") || ["png", "jpg", "jpeg", "gif", "webp"].includes(ext);

  return (
    <div className="position-relative border rounded bg-light overflow-hidden" style={{ width, height }}>
      {!url ? (
        <div className="h-100 d-flex align-items-center justify-content-center text-muted small">{loading === false ? "no preview" : "loading…"}</div>
      ) : isImage ? (
        <img src={url} alt={fileName || ""} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
      ) : isPdf ? (
        <iframe title={fileName || "document"} src={`${url}#toolbar=0&navpanes=0&view=FitH`} style={{ width: "100%", height: "100%", border: 0 }} />
      ) : (
        <div className="h-100 d-flex align-items-center justify-content-center text-muted small p-2 text-center">{fileName}</div>
      )}
      {onOpen && (
        <button
          type="button"
          onClick={onOpen}
          title="Open full size"
          className="position-absolute top-0 start-0 w-100 h-100 border-0 p-0 d-flex align-items-start justify-content-end"
          style={{ background: "transparent", cursor: "zoom-in" }}
        >
          <span className="m-1 px-1 rounded bg-white border d-inline-flex"><Maximize2 size={14} /></span>
        </button>
      )}
    </div>
  );
};

export default InlineFilePreview;
